<template>
  <nav class="bg-white max-w-screen-sm mx-auto w-full" aria-label="底部導覽">
    <div class="grid grid-cols-3 border-t leading-none">
      <nuxt-link
        v-for="(nav, index) in navs"
        :key="index"
        :to="localePath({ name: nav.name })"
        class="block py-2 text-center"
        :class="isActive(nav.names) ? 'text-primary font-bold' : 'text-gray-500'"
        :aria-current="isActive(nav.names) ? 'page' : undefined"
      >
        <component :is="nav.icon" class="mx-auto mb-1" />
        <p class="text-xxs">{{ nav.text }}</p>
      </nuxt-link>
    </div>
  </nav>
</template>

<script>
import { startsWith } from "lodash";
import { HomeIcon, UserIcon, ClipboardIcon } from "@vue-hero-icons/outline";
import { PRIMARY_NAV } from "@/utils/desktopChrome";
export default {
  components: {
    HomeIcon,
    UserIcon,
    ClipboardIcon,
  },
  data() {
    return {
      navs: PRIMARY_NAV,
    };
  },
  methods: {
    isActive(arr) {
      const name = this.$route.name;
      for (let index = 0; index < arr.length; index++) {
        const element = arr[index];
        if (startsWith(name, element)) return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
